// Autocomplete Google Places (proxy PHP) + résolution aéroport / transport.

import { S } from './state.js';
import { $, $$, clearE, debounce } from './dom.js';
import { apiGet } from './api.js';
import { applyAirportResult, applyTransportResult } from './airports.js';

var placesCache = {};
var placesDropdown = null;

export function setupPlacesProxy() {
	var input = $( 'inFactoryAddress' );
	if ( ! input ) return;

	if ( ! placesDropdown ) {
		placesDropdown = document.createElement( 'ul' );
		placesDropdown.id = 'probot-places-dropdown';
		placesDropdown.style.cssText = [
			'position:fixed', 'z-index:999999', 'background:#fff',
			'border:1px solid #DDE4EC', 'border-radius:10px',
			'box-shadow:0 8px 24px rgba(0,0,0,.15)',
			'list-style:none', 'padding:4px 0', 'display:none',
			'max-height:220px', 'overflow-y:auto', 'min-width:300px',
		].join( ';' );
		document.body.appendChild( placesDropdown );
	}

	function position() {
		var r = input.getBoundingClientRect();
		placesDropdown.style.top   = ( r.bottom + 4 ) + 'px';
		placesDropdown.style.left  = r.left + 'px';
		placesDropdown.style.width = r.width + 'px';
	}

	var handler = debounce( function () {
		var q = input.value.trim();
		if ( q.length < 3 ) { placesDropdown.style.display = 'none'; return; }
		if ( placesCache[ q ] ) {
			position();
			showSuggestions( placesCache[ q ], input );
			return;
		}
		apiGet( 'places', { q: q, lang: S.lang } ).then( function ( res ) {
			if ( res && res.data && res.data.predictions ) {
				placesCache[ q ] = res.data.predictions;
				position();
				showSuggestions( res.data.predictions, input );
			}
		} ).catch( function ( e ) { console.warn( 'Places proxy error:', e ); } );
	}, 300 );

	input.addEventListener( 'input', function () {
		clearE( 'f-factory-address' );
		// Toute édition invalide la sélection précédente — sinon on garderait
		// un place_id qui ne correspond plus à l'adresse affichée.
		S.placeId = null;
		S.addressComponents = null;
		handler();
	} );

	// Auto-résolution si l'utilisateur quitte le champ sans cliquer
	// de suggestion. On prend la première prédiction disponible — c'est
	// 99 % du temps la bonne, et le serveur a son propre filet de sécurité.
	input.addEventListener( 'blur', function () {
		setTimeout( function () {
			var q = input.value.trim();
			if ( ! q || q.length < 3 || S.placeId ) return;
			if ( placesCache[ q ] && placesCache[ q ].length ) {
				selectPlace( placesCache[ q ][ 0 ], input, /* silent */ true );
				return;
			}
			apiGet( 'places', { q: q, lang: S.lang } ).then( function ( res ) {
				var preds = res && res.data && res.data.predictions || [];
				placesCache[ q ] = preds;
				if ( preds.length ) selectPlace( preds[ 0 ], input, true );
			} ).catch( function () {} );
		}, 250 ); // laisse le clic de suggestion gagner sur le blur
	} );

	document.addEventListener( 'click', function ( e ) {
		if ( placesDropdown && ! input.contains( e.target ) && ! placesDropdown.contains( e.target ) ) {
			placesDropdown.style.display = 'none';
		}
	} );

	window.addEventListener( 'scroll',  position, { passive: true } );
	window.addEventListener( 'resize',  position, { passive: true } );
}

function showSuggestions( predictions, input ) {
	if ( ! placesDropdown ) return;
	if ( ! predictions.length ) { placesDropdown.style.display = 'none'; return; }

	placesDropdown.innerHTML = predictions.map( function ( p, i ) {
		var main = p.structured_formatting ? p.structured_formatting.main_text : p.description;
		var sec  = p.structured_formatting ? ( p.structured_formatting.secondary_text || '' ) : '';
		return '<li data-idx="' + i + '" style="padding:10px 14px;cursor:pointer;font-size:13px;' +
			'border-bottom:1px solid #EEF3F8;color:#1B2835;background:#fff;display:flex;' +
			'align-items:center;gap:8px;transition:background .15s">' +
			'<span style="color:#778695;flex-shrink:0;font-size:14px">📍</span>' +
			'<span><span style="font-weight:500;color:#1B2835">' + main + '</span>' +
			'<span style="color:#778695;font-size:11px;margin-left:6px">' + sec + '</span></span></li>';
	} ).join( '' );

	$$( 'li', placesDropdown ).forEach( function ( li, i ) {
		li.addEventListener( 'mouseenter', function () { li.style.background = '#F4F7FA'; } );
		li.addEventListener( 'mouseleave', function () { li.style.background = '#fff'; } );
		li.addEventListener( 'click', function () {
			selectPlace( predictions[ i ], input, false );
		} );
	} );

	placesDropdown.style.display = 'block';
}

function selectPlace( place, input, silent ) {
	if ( ! place || ! place.place_id ) return;
	// v1.1.125 — On NE remplit PAS le champ tout de suite avec la description
	// (sans code postal). On attend place-details et on affiche l'adresse COMPLÈTE
	// (code postal inclus) en UNE seule transformation. Le badge « Détection… »
	// donne le feedback immédiat ; fallback sur description si l'appel échoue.
	S.city    = place.description;
	S.placeId = place.place_id;
	S.addressComponents = null;

	if ( placesDropdown ) placesDropdown.style.display = 'none';
	clearE( 'f-factory-address' );

	var badge = $( 'cityBadge' );
	var bText = $( 'cityBadgeText' );
	if ( bText ) bText.textContent = S.lang === 'fr' ? '⏳ Détection en cours…' : '⏳ Detecting airport…';
	if ( badge ) badge.classList.add( 'on' );

	if ( ! silent ) console.debug( '[ProbotSoum] place selected:', place.description, 'place_id:', place.place_id );

	Promise.all( [
		apiGet( 'airport-lookup', { place_id: place.place_id, lang: S.lang } ),
		apiGet( 'place-details', { place_id: place.place_id, lang: S.lang } ),
	] ).then( function ( results ) {
		var lookupRes = results[0];
		var detailsRes = results[1];

		if ( detailsRes && detailsRes.data && detailsRes.data.components ) {
			S.addressComponents = detailsRes.data.components;
		}
		// v1.1.123/125 — UNE seule transformation : on affiche l'adresse complète
		// standardisée par Google (code postal inclus) si dispo, sinon la
		// description en fallback. Pas de champ code postal séparé.
		input.value = ( detailsRes && detailsRes.data && detailsRes.data.formatted_address )
			? detailsRes.data.formatted_address
			: place.description;

		if ( ! lookupRes || ! lookupRes.success || ! lookupRes.data ) {
			var errMsg = ( lookupRes && lookupRes.error ) || 'Erreur inconnue';
			applyAirportResult( null );
			if ( bText ) bText.textContent = '⚠ ' + errMsg;
			if ( badge ) badge.classList.add( 'on' );
			return;
		}

		var d = lookupRes.data;

		if ( d.mode === 'drive' ) {
			applyTransportResult( {
				mode:         'drive',
				driveKm:      d.driveKm,
				driveMinutes: d.driveMinutes || 0,
				haversineKm:  d.haversineKm,
				warning:      d.warning || null,
			} );
			return;
		}

		if ( d.mode === 'fly' && d.airport ) {
			applyTransportResult( {
				mode:        'fly',
				c:           d.airport.iata,
				n:           d.airport.name,
				distanceKm:  d.airport.distanceKm,
				level:       d.airport.level,
				haversineKm: d.haversineKm,
			} );
			return;
		}

		applyAirportResult( null );
		if ( bText ) bText.textContent = S.lang === 'fr' ? '⚠ Aéroport non détecté' : '⚠ Airport not detected';
		if ( badge ) badge.classList.add( 'on' );
	} ).catch( function ( e ) {
		// v1.1.6 — Cleaner error message. Brut exception comme "Unexpected token '<'..."
		// arrive quand WP retourne du HTML au lieu du JSON attendu (route REST
		// temporairement KO, plugin en cours de rebuild, server 502, etc.). On
		// expose un message court + l'erreur en console pour debug, et on
		// suggère un retry à l'utilisateur plutôt que d'afficher l'exception JS.
		// v1.1.125 — Fallback : si place-details échoue, on met au moins la
			// description dans le champ (l'utilisateur voit son adresse choisie).
			if ( place ) input.value = place.description;
			console.warn( '[ProbotSoum] airport-lookup/place-details failed:', e );
		applyAirportResult( null );
		var isParseError = e && e.message && /Unexpected token|JSON/i.test( e.message );
		var msg = S.lang === 'fr'
			? ( isParseError
				? '⚠ Le serveur ne répond pas correctement. Réessayez dans quelques secondes.'
				: '⚠ Erreur réseau. Vérifiez votre connexion et réessayez.' )
			: ( isParseError
				? '⚠ Server response invalid. Please retry in a few seconds.'
				: '⚠ Network error. Check your connection and retry.' );
		if ( bText ) bText.textContent = msg;
		if ( badge ) badge.classList.add( 'on' );
	} );
}
